import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import "./ChocoCraft.css";

function KlyzenChocolates() {
  const highlights = [
    { icon: "🍫", text: "65+ Premium Chocolate Flavours" },
    { icon: "🎨", text: "Luxury & Custom Chocolate Shapes" },
    { icon: "🎁", text: "Retail, Corporate & Gifting Solutions" },
    { icon: "🧪", text: "Strict Quality Control & Hygiene Standards" },
    { icon: "📦", text: "Custom Branding & Premium Packaging" },
    { icon: "🌿", text: "Sustainably Sourced Ingredients" },
    { icon: "💡", text: "Innovative & Artistic Chocolate Designs" },
    { icon: "⚡", text: "Fast & Reliable Delivery" },
  ];

  const products = [
    "Dark Chocolate Collection",
    "Milk Chocolate Collection",
    "White Chocolate Variants",
    "Fruit & Nut Infused Chocolates",
    "Filled & Center-Core Chocolates",
    "Sugar-Free & Diabetic-Friendly Chocolates",
    "Vegan & Plant-Based Chocolates",
    "Seasonal & Festival Special Editions",
  ];

  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="choco-hero">
        <div className="choco-overlay" />
        <div className="choco-hero-content">
          <h1>Klyzen Chocolates</h1>
          <h2>Premium Chocolate Manufacturing</h2>
          <p>
            A luxury chocolate brand crafting exceptional flavours and artistic
            designs — proudly a Food & Hospitality division of{" "}
            <strong>Klyzen Ventures LLP</strong>.
          </p>
        </div>
      </section>

      {/* ABOUT */}
      <section className="choco-section">
        <h2>About Klyzen Chocolates</h2>
        <p className="choco-text">
          Klyzen Chocolates is dedicated to crafting world-class premium
          chocolates using the finest ingredients, innovative techniques, and
          artistic moulding. With over <strong>65+ flavours</strong> and a wide
          range of customizable shapes, we sell directly to consumers through
          retail, corporate gifting, and exclusive online channels.
        </p>
      </section>

      {/* HIGHLIGHTS */}
      <section className="choco-section choco-alt">
        <h2>Why Choose Klyzen Chocolates</h2>
        <div className="choco-grid">
          {highlights.map((item, idx) => (
            <div key={idx} className="choco-card">
              <span className="choco-icon">{item.icon}</span>
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PRODUCTS */}
      <section className="choco-section">
        <h2>Our Chocolate Range</h2>
        <div className="products-grid">
          {products.map((product, idx) => (
            <div key={idx} className="product-card">
              <span>🍬</span>
              <p>{product}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PREMIUM CRAFT */}
      <section className="choco-section choco-alt">
        <h2>Premium Chocolate Craftsmanship</h2>
        <p className="choco-text">
          From flavour formulation and custom moulds to premium packaging, Klyzen
          Chocolates provides complete end-to-end solutions for our own brand. We
          focus on delivering directly to customers, ensuring every chocolate is
          fresh, luxurious, and unforgettable.
        </p>
      </section>

      {/* CTA */}
      <section className="choco-cta">
        <h2>Get Your Klyzen Chocolates Today</h2>
        <p>
          Indulge in handcrafted premium chocolates with exquisite flavours and
          artistic designs.
        </p>
        <Link to="/contact" className="cta-btn">
          Order Now
        </Link>
      </section>

      <Footer />
    </>
  );
}

export default KlyzenChocolates;
